(function () {
  'use strict';

  function ReceiptController ($state, Common, paymentFactory, $sce, $scope) {
    const vm = this;

    function getDateTime () {
      return moment(vm.product.deliveryDate).format('DD MMM');
    }

    function goToMain () {
      const states = {
        'admail-postcard': 'main.admail',
        'admail-letter': 'main.admail',
        'admail-flyers': 'main.admail',
        'information': 'main.landing'
      };

      const landingState = states[Common.get('serviceType', 'information')];
      Common.resetOrderData();
      $state.go(landingState);
    }

    function isSTF () {
      return Common.get('productDelivery', {}).printProvider === 'stralfors';
    }


    function getWhatToSendDescription () {
      let message = null;
      const addressType = Common.get('recipients.addressType', 'FILE');
      const targetType = Common.get('recipients.targetType', 'FILE');

      switch (vm.serviceType) {
        case 'information':
          message = 'INFORMATION_DESCRIPTION';
          break;
        case 'paymentSlips':
          message = 'PAYMENT_SLIPS_DESCRIPTION';
          break;
        case 'admail-letter':
          if (addressType === 'ADR') {
            message = (targetType === 'INDIVIDUALS') ? 'ADMAIL_LETTER_ADR_INDIVIDUALS_DESCRIPTION' : 'ADMAIL_LETTER_ADR_FILE_DESCRIPTION';
          } else {
            message = 'ADMAIL_FLYER_DESCRIPTION';
          }
          break;
        case 'admail-postcard':
          if (addressType === 'ADR') {
            if (targetType === 'INDIVIDUALS') {
              message = 'ADMAIL_POSTCARD_ADR_INDIVIDUALS_DESCRIPTION';
            } else {
              message = 'ADMAIL_POSTCARD_ADR_FILE_DESCRIPTION';
            }
          } else {
            message = 'ODR_DESCRIPTION';
          }
          break;
        default:
          message = null; //FIXME Unknown service type. Need to set default
          break;
      }

      return message;
    }

    function activate () {
      // models
      vm.orderId = Common.get('orderId');
      vm.product = Common.get('productDelivery');
      vm.ownMaterial = vm.product.ownMaterial;
      vm.paymentDetails = paymentFactory.extractCalculatedPrice();
      vm.pdf = $sce.trustAsResourceUrl(Common.get('s3Pdf'));
      vm.serviceType = Common.get('serviceType');
      vm.email = Common.get('addressInfo').email;
      vm.materialDetails = Common.get('materialDetails', {});
      vm.sendoutName = Common.get('sendoutName', '');
      vm.receiptUrl = Common.get('receiptUrl', '');
      vm.cartId = Common.get('cartId', '');

      // methods
      vm.getDateTime = getDateTime;
      vm.goToMain = goToMain;
      vm.receipt = true;
      vm.language = pnTopbar.language;
      vm.whatToSend = getWhatToSendDescription();
      vm.isSTF = isSTF();

      $scope.$on('changeLanguage', function (ev, language) {
        vm.language = language;
        Common.notifyObserver('web2print.pricing');
      });

      console.log('ReceiptController activated');
    }

    function checkSession () {
      if (!Common.get('orderId')) {
        $state.go('main.landing');
        return;
      }

      activate();
    }

    checkSession();
  }

  angular.module('web2print.receipt')
    .controller('ReceiptController', ReceiptController);

  ReceiptController.$inject = ['$state', 'Common', 'paymentFactory', '$sce', '$scope'];
})();
